import * as React from 'react';

function SvgIllustrator(props) {
  return (
    <svg
      width={574}
      height={438}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <defs>
        <path
          d="M39.806 62.464s1.733 12.113 6.931 13.692c5.198 2.13 10.489-3.804 3.467-5.287 0 0-3.716-5.438-2.476-12.112 1.238-6.674 12.862-30.652 8.535-45.98C50.857-6.38 45.994 5.227 45.994 5.227l-7.921.319S34.479-.888 31.26 2.213c-3.218 3.103-5.92 16.744-3.39 21.689 0 0-21.237 6.18-25.942 26.203-3.92 16.691 5.2 22.495 12.626 25.213 7.427 2.72 25.517 4.163 24.509-1.482-.743-4.164-5.362-2.906-5.362-2.906l6.105-8.466"
          id="illustrator_svg__a"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path fill="#AD5B2E" d="M376 113l9.698 75H490.59L492 113z" />
        <path fill="#FFF9CC" d="M380 117l10.345 66h95.9L488 117z" />
        <path fill="#95BBB4" d="M403 134l2.991 32.08 56.78.92L466 134z" />
        <path
          d="M405 150.395l1.459 15.683 56.747.922L465 148.63c-4.701-2.07-13.69-2.919-26.967-2.544-13.276.375-24.287 1.812-33.033 4.31z"
          fill="#91AA3D"
        />
        <g fillRule="nonzero">
          <g transform="translate(130 87.712)">
            <ellipse fill="#FFF" cx={43} cy={40.215} rx={29} ry={15.479} />
            <path d="M86 43.79C86 19.605 66.748 0 43 0S0 19.605 0 43.79" fill="#63656A" />
          </g>
          <path fill="#63656A" d="M170.828 0h4.344v94h-4.344z" />
        </g>
        <g fillRule="nonzero">
          <g transform="translate(209 53.437)">
            <ellipse fill="#FFF" cx={32.5} cy={34.5} rx={19} ry={10.88} />
            <path d="M65 35.508C65 15.898 50.45 0 32.5 0S0 15.897 0 35.508" fill="#7D7F82" />
          </g>
          <path fill="#7D7F82" d="M239.743 0h4.392v73h-4.392z" />
        </g>
        <path
          d="M310 438c99.411 0 180-6.65 180-11.574 0-4.924-18-8.307-180-11.574-162-3.266-180 3.467-180 9.86C130 431.103 210.589 438 310 438z"
          fill="#B0D6D3"
          opacity={0.4}
        />
        <path
          d="M70.957 416.856c0 2.035-11.749 3.684-26.241 3.684-14.492 0-26.24-1.649-26.24-3.684 0-2.033 11.748-3.682 26.24-3.682 14.492 0 26.241 1.649 26.241 3.682"
          fill="#BCE0DD"
        />
        <path
          d="M51.798 355.689s5.757-96.402 46.043-84.892c0 0-24.46 1.44-46.043 84.892m-18.705 15.828c-.987 4.443.001-103.596-33.093-97.842 0 0 61.871-31.653 33.093 97.842"
          fill="#7B923C"
        />
        <path
          d="M43.165 374.395C40.287 367.201 23.022 221.878 50.36 219l-7.195 155.395"
          fill="#525F2E"
        />
        <path
          d="M24.46 358.567s15.828-102.157 86.331-66.187c0 0-35.972-11.51-86.331 66.187"
          fill="#91AA3D"
        />
        <path
          d="M43.764 349.309c0-2.878 7.675-106.479 39.331-110.316 0 0-26.86 62.352-29.738 108.398l-9.593 1.918"
          fill="#7B923C"
        />
        <path
          d="M20.742 342.594s-3.838-41.249-18.227-47.964c0 0 28.779 5.756 29.738 48.924l-11.511-.96"
          fill="#525F2E"
        />
        <path
          d="M75.056 360.663c0 12.375-1.4 22.846-3.943 31.403-4.978 16.807-14.341 25.833-26.034 25.833-17.641 0-33.892-20.504-33.892-57.216 0-4.461.22-30.395.614-34.395h62.642c.402 4 .613 29.914.613 34.375"
          fill="#FFF"
        />
        <path
          d="M11.801 326.288c-.394 4-.614 29.953-.614 34.414 0 36.713 16.251 57.237 33.892 57.237 11.693 0 21.056-8.986 26.034-25.793-36.577 11.905-50.995-42.858-55.437-65.858h-3.875z"
          fill="#F0FFFE"
        />
        <path
          fill="#804E28"
          d="M451.72 387.222L460.356 430h-4.32l-17.445-42.778h13.13m-286.665 0L156.421 430h4.318l17.447-42.778h-13.13"
        />
        <path
          d="M452.904 344.084l-145.291 3.472-145.296-3.472s-16.541-63.206-16.722-74.41c-.057-3.304-.194-6.698.368-9.918 1.348-7.702 6.709-14.428 26.847-16.648 27.023-2.982 124.456-1.963 134.878-1.846 11.186-.127 107.83-1.124 134.726 1.846 14.043 1.548 20.901 5.29 24.22 10.024 3.435 4.89 3.087 10.847 2.996 16.543-.183 11.203-16.726 74.41-16.726 74.41z"
          fill="#38B2A6"
        />
        <path
          d="M147.093 259.667c1.35-7.666 6.717-14.36 26.878-16.57 15.575-1.708 54.517-2.097 86.746-2.097 23.754 0 43.858.211 48.286.261 4.726-.054 24.696-.261 48.217-.261 32.215 0 71.098.39 86.663 2.098 14.058 1.54 20.925 5.264 24.247 9.976-17.612-4.09-34.157-7.226-53.238-7.226l-.72.002c-50.483.201-99.997 8.406-150.398 8.406-5.023 0-10.054-.081-15.097-.26-7.461-.263-29.666-2.414-51.96-2.414-19.98 0-40.031 1.726-49.624 8.085"
          fill="#4CCCBF"
        />
        <path fill="#2FA095" d="M162.64 360h290.72v-28H162.64z" />
        <path fill="#35AA9F" d="M161.862 402h293.053v-22.556H161.862z" />
        <path
          d="M454.243 383.333v-3.889h.567c-.016.19-.031.376-.031.562 0 .914-.163 1.666-.536 2.284v1.043"
          fill="#C97F62"
        />
        <path
          d="M319.819 391.889c-1.97 0-3.751-.017-5.324-.052-25.235-.57-127.134-5.8-152.633-6.77v-5.623h1.943v1.437s73.211 5.87 150.688 5.87c66.018 0 136.46-5.657 139.017-5.864l.061-.005h.009v-1.438h1.335v3.48c-.222.033-.444.069-.674.104-2.762.427-5.846.85-9.195 1.267-34.782 4.281-97.923 7.594-125.227 7.594"
          fill="#2B948A"
        />
        <path
          d="M452.583 342.889v39.059S380.897 388 313.789 388c-77.315 0-150.372-6.052-150.372-6.052v-39.06s47.753.69 78.83 3.115c9.253.723 99.201 2.59 146.4 1.484 34.686-.813 63.936-4.598 63.936-4.598"
          fill="#38B2A6"
        />
        <path
          d="M449.34 331.222h-49.615c3.214-15.597 53.245-35.778 53.245-35.778 4.488 3.956 6.268 11.223 4.192 15.965-1.193 2.729-4.288 12.262-7.823 19.813"
          fill="#2CA89C"
        />
        <path
          d="M440.843 342.111c-.035 0-.065 0-.1-.002-6.2-.323-40.245-2.658-41.494-7.027-.357-1.248-.389-2.539-.14-3.86h49.587c-2.575 6.02-5.382 10.89-7.853 10.89"
          fill="#1F9589"
        />
        <path
          d="M453.311 298.387c-2.516 7.862-12.165 38.131-12.165 39.895 0 2.58-4.308 2.297-3.566 2.23 3.153-.28-36.995-2.986-38.096-4.351-1.1-1.366-2.722-4.9 1.011-17.568 2.77-9.398 6.632-17.324 9.763-23.374.927-1.79 1.677-3.044 3.365-2.87 7.597.79 29.249 3.036 37.457 3.89.707.074 2.609.97 2.231 2.148"
          fill="#E7E7E7"
        />
        <path
          d="M452.439 297.372c-1.893-1.795-5.995 2.937-8.568 13.642-2.574 10.705-11.014 28.165-6.106 28.726 7.437.85 10.165-12.836 13.162-23.35 2.997-10.515 4.667-16.029 1.512-19.018"
          fill="#CBCACA"
        />
        <path
          d="M220.162 331.222h-49.634c-3.514-7.682-6.611-17.304-7.792-19.943-2.105-4.704-.297-11.911 4.255-15.835l53.17 35.778"
          fill="#2CA89C"
        />
        <path
          d="M178.974 342.111c-2.424-.001-5.216-4.887-7.784-10.889h49.296l2.008 1.445s-37.314 7.858-43.067 9.385c-.15.04-.3.06-.453.06"
          fill="#1F9589"
        />
        <path
          d="M116.773 313.657c2.34-9.027 17.9-18.227 31.474-12.602 8.89 3.682 14.123 11.529 20.735 23.89 9.507 17.776 6.38 41.156 6.38 54.41 0 2.051-.827 3.2-6.552 3.2-5.974 0-7.865-.68-7.865-4.506 0-8.458-5.794-19.285-13.227-25.989-17.185-15.498-35.761-19.826-30.945-38.403m351.522 38.685c-7.279 6.603-13.025 19.004-13.247 27.503-.008.174-.017.345-.017.515 0 .84-.09 1.531-.293 2.099a2.82 2.82 0 01-.656 1.065c-1.09 1.107-3.226 1.365-6.908 1.365-.788 0-1.482-.023-2.095-.065-3.35-.235-4.248-1.101-4.422-2.504a4.259 4.259 0 01-.026-.336c-.008-.102-.008-.208-.008-.314 0-.586-.005-1.194-.017-1.825-.09-5.309-.507-12.157-.456-19.544.034-4.782.26-9.794.898-14.766.12-.927.256-1.854.405-2.776.57-3.55 1.379-7.05 2.503-10.404a47.273 47.273 0 013.09-7.276c5.508-10.357 10.063-17.564 16.575-21.82a25.254 25.254 0 014.15-2.196c13.566-5.653 29.116 3.597 31.457 12.668 4.81 18.68-13.753 23.03-30.933 38.611"
          fill="#52CCC0"
        />
        <path
          d="M168.13 295.276c2.516 7.863 12.166 38.131 12.166 39.896 0 2.58 4.307 2.296 3.565 2.23-3.155-.28 36.996-2.987 38.096-4.352 1.1-1.366 2.722-4.9-1.01-17.568-2.77-9.398-6.633-17.324-9.764-23.374-.927-1.79-1.677-3.044-3.365-2.87-7.598.79-29.248 3.036-37.46 3.89-.704.074-2.605.97-2.228 2.148"
          fill="#FEDD48"
        />
        <path
          d="M169.003 295.038c1.895-1.795 5.996 2.937 8.569 13.642 2.571 10.706 11.011 28.166 6.105 28.727-7.435.849-10.165-12.836-13.162-23.351-2.997-10.515-4.669-16.029-1.512-19.018"
          fill="#E5C63A"
        />
        <g>
          <path fill="#AD5B2E" d="M574 217l-2.435-73.15L524 143l1.557 74H574" />
          <path fill="#FFF9CC" d="M566.807 147H529v65h40z" />
          <path fill="#E16B5E" d="M556 162h-17v38h17z" />
        </g>
        <g>
          <path
            d="M282.558 328.033c-2.35-1.862-4.335-4.254-5.657-6.991a18.986 18.986 0 01-1.894-8.77c.07-2.995.845-5.905 2.079-8.512 1.226-2.623 2.92-4.94 4.824-6.984l1.356-1.403.301-.315.279-.334c.18-.223.385-.434.548-.671.715-.91 1.293-1.91 1.777-2.952a14.589 14.589 0 001.32-6.724c-.104-2.309-.775-4.626-2.007-6.52-1.206-1.904-3.099-3.288-5.087-3.298h-.034a1.437 1.437 0 01-.044-2.873 8.126 8.126 0 014.555 1.232c.676.393 1.257.89 1.817 1.4.53.53 1.033 1.09 1.458 1.694 1.727 2.405 2.67 5.233 2.94 8.107a18.342 18.342 0 01-1.261 8.534c-.547 1.346-1.228 2.648-2.066 3.831-.195.308-.43.583-.645.874l-.33.431-.355.409-1.293 1.47c-1.56 1.842-2.877 3.853-3.758 6.002-.89 2.14-1.36 4.404-1.306 6.622a13.737 13.737 0 001.667 6.285c1.039 1.913 2.542 3.566 4.338 4.857a2.893 2.893 0 01.658 4.043 2.902 2.902 0 01-4.048.657l-.101-.074-.031-.027"
            fill="#A96F4A"
          />
          <path
            d="M329.637 311.15s-1.624 16.437 2.338 22.618c0 0 3.465-.742 3.96 1.977.495 2.72-5.534 4.222-7.674 1.979-4.95-5.192-4.208-13.844-4.95-19.406l6.326-7.169"
            fill="#E3D2BF"
          />
          <path
            d="M318.73 327.464s1.733 12.113 6.932 13.692c5.198 2.13 10.488-3.804 3.466-5.287 0 0-3.715-5.438-2.476-12.112 1.238-6.674 12.862-30.652 8.536-45.98-5.406-19.158-10.27-7.551-10.27-7.551l-7.921.319s-3.594-6.433-6.813-3.332c-3.217 3.103-5.919 16.744-3.39 21.689 0 0-21.237 6.18-25.941 26.203-3.921 16.691 5.2 22.495 12.626 25.213 7.427 2.72 25.516 4.163 24.508-1.482-.742-4.164-5.362-2.906-5.362-2.906l6.105-8.466"
            fill="#E3D2BF"
          />
          <g transform="translate(278.924 265)">
            <mask id="illustrator_svg__b" fill="#fff">
              <use xlinkHref="#illustrator_svg__a" />
            </mask>
            <path
              d="M60.23 17.683c.222-.272.38-.585.442-.93.297-1.683-.07-3.329-.8-4.881-.365-1.41-1.029-2.77-1.733-3.818-1.407-2.085-3.134-4.297-5.324-5.6-.686-.409-1.363-.6-2.005-.624-2.3-1.643-4.964-2.708-7.116-.929-.722.597-.943 1.315-.835 1.988a2.268 2.268 0 00-1.553-.137h-.278c-1.359-.489-2.903.054-4.28.838-1.286-2.026-3.793-2.993-6.684-2.067-2.152.688-3.138 3.38-1.522 4.083-1.623 1.28-1.713 3.066-2.456 4.47-.703 1.326-1.094 2.91-.715 4.356-.722 1.396-1.01 2.887-.181 4.21.463.736 1.008 1.22 1.603 1.507.99 1.762 3.192 2.394 5.391 2.002 2.699-.483 5.278-2.217 7.23-4.09.354-.339.724-.715 1.1-1.117.6 2.363 2.49 4.636 4.282 5.98 3.185 2.393 7.082 3.554 10.975 4.19.53.11 1.065.192 1.612.233 2.952.223 3.24-3.722 1.02-4.867a5.402 5.402 0 002.251-1.675c.87-1.084.629-2.514-.423-3.122M37.454 40.916c.229-2.449-.801-5.022-1.81-7.19-1.06-2.284-2.73-4.32-4.29-6.276-.714-.897-1.479-1.744-2.244-2.597-.801-.894-1.966-1.232-2.965-1.889-.629-.412-1.387.073-1.508.72-.445-.173-.965-.227-1.548-.105-2.303.478-4.316.939-6.467 1.956-2.274 1.073-4.37 2.48-6.352 4.02-3.83 2.97-7.057 6.621-9.603 10.74-4.48 7.243-5.773 15.521-2.873 23.575 2.492 6.926 7.763 13.45 15.524 14.176 4.011.376 7.112-1.73 10.45-3.526 2.95-1.587 6.21-2.544 9.005-4.43 3.12-2.105 5.02-5.452 3.678-9.212-.793-2.22-2.093-4.238-2.78-6.495-.68-2.234.378-4.416 1.382-6.367 1.18-2.301 2.158-4.499 2.401-7.1"
              fill="#A96F4A"
              mask="url(#illustrator_svg__b)"
            />
            <path
              d="M41.41.89c-1.04 2.614-2.036 6.536-.93 9.26.15.37.769.607.981.127.63-1.425.796-2.993 1.068-4.52.28-1.548.652-3.039.82-4.606.128-1.195-1.562-1.207-1.939-.262M29.992 13.666c-1.227-.68-2.445-1.412-3.708-2.02-1.12-.54-2.359.564-1.724 1.721.955 1.744 4.09 2.935 5.533 1.08.19-.245.207-.612-.1-.781m-1.958 4.817c-1.288-.096-2.193-.77-3.066-1.666-.764-.78-2.116.235-1.521 1.172 1.077 1.688 3.034 2.193 4.78 1.202.35-.199.169-.683-.193-.708m30.114-5.387c-.737.43-1.462.865-2.265 1.166-.782.293-1.57.496-2.333.84-.773.35-.334 1.48.408 1.501 1.912.056 4.117-.437 5.594-1.691 1.022-.868-.292-2.464-1.404-1.816m3.58 7.456c-1.116-.57-2.24-.293-3.451-.348-1.3-.059-2.552-.281-3.827-.53-.513-.1-1.027.551-.555.955 1.91 1.631 5.788 3.73 8.075 1.807.576-.486.41-1.55-.243-1.884M23.602 40.05c-3.06-.4-4.36-3.998-5.225-6.491-1.031-2.967-1.59-6.13-2.258-9.195-.272-1.25-2.055-.878-2.13.29-.246 3.86.494 7.93 1.978 11.503 1.302 3.135 3.997 6.91 7.888 5.761 1.106-.326.76-1.735-.253-1.868m-8.517-.083c-1.004-1.168-2.057-2.108-2.608-3.596-.48-1.3-.585-2.849-.573-4.225.01-1.103-1.455-1.172-1.814-.245-1.25 3.23.655 8.725 4.643 8.916.468.023.616-.543.352-.85"
              fill="#72432A"
              mask="url(#illustrator_svg__b)"
            />
            <path
              d="M23.675 32.754c-2.337-2.412-1.876-6.703-2.466-9.743-.196-1.007-1.847-1.015-2.036 0-.57 3.07-.304 10.565 4.087 10.741.526.022.758-.645.415-.998M16.24 50.696c-3.37-.906-5.412-3.43-7.012-6.39-1.685-3.118-2.101-6.466-3.087-9.793-.372-1.261-2.252-1.313-2.6 0-1.035 3.896 1.372 8.836 3.322 12.113 1.782 2.996 5.68 7.21 9.507 5.06.41-.23.32-.87-.13-.99m-8.639 2.192c-1.243-1.31-2.536-2.363-3.495-3.93-.94-1.533-1.44-3.26-2.296-4.83-.618-1.139-2.218-.538-2.294.62-.244 3.768 3.359 9.475 7.372 9.864.926.091 1.27-1.136.713-1.724"
              fill="#72432A"
              mask="url(#illustrator_svg__b)"
            />
          </g>
          <path
            d="M332.186 337.47a6.174 6.174 0 00-.725-.763 5.175 5.175 0 00-.825-.607 3.599 3.599 0 00-.909-.38 2.718 2.718 0 00-.937-.072l-.22.02-.119-.23c-.577-1.12-1.153-2.281-1.532-3.535a14.625 14.625 0 01-.444-1.906c-.051-.324-.075-.651-.112-.975-.024-.325-.033-.65-.05-.976-.017-1.302.14-2.59.395-3.844.258-1.258.653-2.477 1.125-3.66-.14 1.27-.346 2.513-.432 3.762-.11 1.244-.166 2.484-.103 3.71.022.306.035.613.065.917.042.303.067.608.123.908a13.9 13.9 0 00.38 1.79c.31 1.184.78 2.335 1.234 3.52l-.337-.21a3.373 3.373 0 012.117.813 4.852 4.852 0 011.306 1.717"
            fill="#AF9B8A"
          />
          <path
            d="M319.02 281.125c-3.315.428-8.836 9.614-3.054 9.003.964-.103 1.62-.6 2.005-1.225.093.193.197.38.327.555l.015.019c.485.654 1.267 1.09 2.068 1.202 1.123.157 2.838-.082 2.957-1.205.44-4.164-2.936-8.528-4.318-8.35"
            fill="#FFFFFE"
          />
          <path
            d="M318.513 285.373c1.515.171 2.416.354 1.162 1.272-1.252.917-1.663.991-3.046-.2-1.38-1.189.77-1.2 1.884-1.072"
            fill="#A96F4A"
          />
          <path
            d="M327.023 271.412s1.159-3.687 2.646-2.389c1.484 1.298 2.517 4.1 2.517 4.1l-5.163-1.71m-12.174 0s-3.304-5.33-5.65 1.483l5.65-1.484"
            fill="#D09A8B"
          />
          <path
            d="M327.525 281.763c0 1.274-1.173 2.307-2.62 2.307-1.448 0-2.622-1.033-2.622-2.307 0-1.273.328-2.484 1.777-2.484 1.448 0 3.465 1.21 3.465 2.484"
            fill="#FFFFFE"
          />
          <path
            d="M323.435 281.75c-.091-.668.356-1.278.996-1.363.639-.086 1.23.384 1.32 1.05.09.668.028 1.322-.61 1.407-.64.088-1.617-.427-1.706-1.095"
            fill="#3A383B"
          />
          <path
            d="M313.27 283.754c-1.24-.299-1.97-1.68-1.63-3.086.34-1.406 1.622-2.3 2.862-2.002 1.24.298 2.341.902 2.001 2.308-.34 1.406-1.992 3.08-3.233 2.78"
            fill="#FFFFFE"
          />
          <path
            d="M314.244 279.786c.67.07 1.16.647 1.094 1.288-.065.64-.665 1.103-1.336 1.034-.67-.07-1.29-.281-1.225-.922.066-.64.796-1.467 1.467-1.4"
            fill="#3A383B"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgIllustrator;
